var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    attrs: {
      "to": {
        name: 'conciliacaoBancariaNova'
      }
    }
  }, [_c('Upload', {
    staticClass: "mr-1",
    attrs: {
      "size": 16
    }
  }), _vm._v(" Importar OFX ")], 1)], 1)]), _c('div', {
    staticClass: "card-body pt-0 pb-2"
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Banco",
      "label-for": "filtro_banco"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filtro_banco",
      "placeholder": "Filtrar por banco"
    },
    on: {
      "input": _vm.filtrar
    },
    model: {
      value: _vm.filtros.banco,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "banco", $$v);
      },
      expression: "filtros.banco"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "filtro_status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "filtro_status"
    },
    on: {
      "change": _vm.filtrar
    },
    model: {
      value: _vm.filtros.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "status", $$v);
      },
      expression: "filtros.status"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _c('b-form-select-option', {
    attrs: {
      "value": "pendente"
    }
  }, [_vm._v("Pendente")]), _c('b-form-select-option', {
    attrs: {
      "value": "parcial"
    }
  }, [_vm._v("Parcial")]), _c('b-form-select-option', {
    attrs: {
      "value": "concluido"
    }
  }, [_vm._v("Concluído")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data início",
      "label-for": "filtro_data_inicio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filtro_data_inicio",
      "type": "date"
    },
    on: {
      "change": _vm.filtrar
    },
    model: {
      value: _vm.filtros.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicio", $$v);
      },
      expression: "filtros.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data fim",
      "label-for": "filtro_data_fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filtro_data_fim",
      "type": "date"
    },
    on: {
      "change": _vm.filtrar
    },
    model: {
      value: _vm.filtros.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_fim", $$v);
      },
      expression: "filtros.data_fim"
    }
  })], 1)], 1)], 1), !_vm.isLoading ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _c('tbody', [_vm.conciliacoesFiltradas.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(" Nenhuma conciliação encontrada. ")])]) : _vm._e(), _vm._l(_vm.conciliacoesFiltradas, function (item, index) {
    return _c('tr', {
      key: 'conciliacao-' + index
    }, [_c('td', [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.banco_nome))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.banco_codigo))])]), _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Ag: " + _vm._s(item.agencia))]), _c('br'), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Cc: " + _vm._s(item.conta))])]), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_importacao)))]), _c('td', [_c('small', [_vm._v(" " + _vm._s(_vm.formatDate(item.data_inicio_ofx)) + " até " + _vm._s(_vm.formatDate(item.data_fim_ofx)) + " ")])]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.total_lancamentos))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.total_conciliados))]), _c('td', {
      staticStyle: {
        "min-width": "140px"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "flex-grow-1 mr-2"
    }, [_c('b-progress', {
      attrs: {
        "value": item.percentual,
        "max": 100,
        "variant": _vm.getProgressVariant(item.percentual),
        "height": "10px"
      }
    })], 1), _c('span', {
      staticClass: "font-weight-bold",
      class: _vm.getTextVariant(item.percentual),
      staticStyle: {
        "min-width": "40px"
      }
    }, [_vm._v(" " + _vm._s(item.percentual) + "% ")])])]), _c('td', [_c('span', {
      class: _vm.getBadgeClass(item.status)
    }, [_vm._v(" " + _vm._s(_vm.getLabelStatus(item.status)) + " ")])]), _c('td', [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "gap": "6px"
      }
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Ver detalhe',
        expression: "'Ver detalhe'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-info btn-hover-info btn-icon",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.abrirDetalheConciliacao(item);
        }
      }
    }, [_c('Eye', {
      attrs: {
        "size": 16
      }
    })], 1), item.arquivo_ofx_url ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Baixar arquivo OFX',
        expression: "'Baixar arquivo OFX'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-secondary btn-hover-secondary btn-icon",
      attrs: {
        "href": item.arquivo_ofx_url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('Download', {
      attrs: {
        "size": 16
      }
    })], 1) : _vm._e(), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Excluir conciliação',
        expression: "'Excluir conciliação'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon",
      on: {
        "click": function click($event) {
          return _vm.excluirConciliacao(item);
        }
      }
    }, [_c('TrashCanIcon', {
      attrs: {
        "size": 16
      }
    })], 1)])])]);
  })], 2)])]) : _vm._e(), _vm.isLoading ? _c('div', {
    staticClass: "d-flex justify-content-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando..."
    }
  })], 1) : _vm._e()], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Conciliações Bancárias ")]), _c('span', {
    staticClass: "text-muted mt-3 font-weight-bold font-size-sm"
  }, [_vm._v(" Gerencie as conciliações importadas via arquivo OFX ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Banco")]), _c('th', [_vm._v("Conta")]), _c('th', [_vm._v("Lançamento")]), _c('th', [_vm._v("Período OFX")]), _c('th', [_vm._v("Total Lançamentos")]), _c('th', [_vm._v("Conciliados")]), _c('th', [_vm._v("% Conclusão")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Ações")])])]);
}];
export { render, staticRenderFns };